import cn from 'classnames';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

// CSS
import styles from './Maintenance.scss';
import icon from './images/icon_maintanance.svg';

const MaintananceView: React.FC<{}> = ({}) => {
    const { t } = useTranslation();

    useEffect(() => {
        Logger.log(LoggerLevel.UseEffect, { source: LoggerSource.React, component: 'Maintanance', message: 'REACT :: VIEW :: Maintanance' });
    }, []);

    return (
        <div className={styles.maitanance_module}>
            <div className={styles.maitanance_overlay}>
                <div className={styles.maitanance_container}>
                    <div className={styles.maitanance_image}>
                        <img src={icon} alt="maitanance icon image" />
                    </div>
                    <div className={styles.maitanance_text}>
                        <h1> {t('MAINTENANCE_MODE_HEADER')}</h1>
                        <p>{t('MAINTENANCE_MODE_TEXT')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaintananceView;

/*
<div className={styles['maintenance__container']}>
            <div className={styles['maintenance__dialog']}>
                <div className={styles['maintenance__dialog-message']}>
                    {t('MAINTENANCE_MODE_HEADER')}
                    <p>{t('MAINTENANCE_MODE_TEXT')}</p>
                </div>
            </div>
        </div>
*/
